export default __webpack_public_path__ + "static/media/AvgGuestCheck.c6696d2a.svg";